import type { ReactNode } from 'react';

/** The bar that sticks to the bottom while rows are ticked. */
export function SelectionBar({ children }: { children: ReactNode }) {
  return (
    <section
      aria-label="Selected"
      className="sticky bottom-4 z-[5] flex flex-wrap items-center gap-x-3 gap-y-2 rounded-[12px] border border-line-strong bg-card py-2.5 pr-3 pl-4 shadow-[var(--shadow-lg)]"
    >
      {children}
    </section>
  );
}
